// export default Imcoechart;
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import axiosInstance from "../api/axiosInstance";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Imcoechart = () => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [loading, setLoading] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const getFontSize = () => {
    if (windowWidth > 3000) return 24;
    if (windowWidth > 2500) return 19;
    if (windowWidth >= 2000) return 15;
    if (windowWidth >= 1600) return 13;
    return 11;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Use axiosInstance to ensure auth headers are included
        const response = await axiosInstance.get(`dashboard/getTotalAmountByPaymentMethod`);

        // Handle potential response structures
        const resData = response.data;
        // Check if data is in resData.data (common wrapper) or resData directly
        const dataArray = (Array.isArray(resData.data) ? resData.data : (Array.isArray(resData) ? resData : []));

        if (dataArray.length > 0) {
          const labels = dataArray.map(
            (item) => item.name?.trim() || "Unknown"
          );
          const values = dataArray.map(
            (item) => Number(item.total_amount) || 0
          );

          setChartData({
            labels,
            datasets: [
              {
                label: "Payment Totals",
                data: values,
                backgroundColor: ["#318965", "#4287f5", "#f59e42", "#c74f4f"],
                borderColor: "#fff",
                barPercentage: 0.6,
                categoryPercentage: 0.6,
              },
            ],
          });
        } else {
          console.warn("⚠️ No valid data found in API response");
          // Ensure we don't keep old data if new fetch returns empty
          setChartData({ labels: [], datasets: [] });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: getFontSize(),
          },
        },
      },
      title: {
        display: true,
        text: "Total Amount by Payment Method",
        font: {
          size: getFontSize(),
        },
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: getFontSize(),
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => value.toLocaleString(),
          stepSize: 10000,
          font: {
            size: getFontSize(),
          },
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", margin: "0 auto", }} className="chartFull" >
      {loading ? (
        <p style={{ textAlign: "center", marginTop: "150px" }}>
          Loading chart...
        </p>
      ) : chartData.labels.length > 0 ? (
        <Bar data={chartData} options={options} key={windowWidth} />
      ) : (
        <p style={{ textAlign: "center", marginTop: "150px" }}>
          No payment data available
        </p>
      )}
    </div>
  );
};

export default Imcoechart;
